import { Tooltip } from 'component-library';
import { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppContext } from '../../contexts/AppContext';
import { Oem } from '../../models/ApiModels';
import { GetOem, GetOems, GetOemsIndirect, UpdateOemAsync } from '../../services/OemService';
import { ActionType } from '../../store/actionTypes';
import { LoadingSpinner } from '../../utils/LoadingSpinner';
import { ToggleButton } from '../../utils/ToggleButton';
import useAsyncToggle from '../../utils/useAsyncToggle';

export const SettingsCustomerSettings = () => {
  const dispatch = useDispatch();
  const { currentOem, currentOemTenantId, isHumphreeUser, setCurrentOem } = useContext(AppContext);
  const oems = useSelector((state: any) => state.oems.data);
  const selectedOem: Oem | undefined = oems.find((oem: Oem) => oem.id === currentOemTenantId) || currentOem;
  console.log(selectedOem);
  console.log(oems);
  console.log(currentOemTenantId);

  const {
    value: allowSettingPresetFromCp,
    isUpdating,
    toggle: toggleAllowSettingPresetFromCp,
  } = useAsyncToggle({
    syncedValue: selectedOem?.settings?.allowSetPresetFromControlPanel === true,
    onUpdate: async (nextAllowSettingPresetFromCp) => {
      if (!selectedOem) {
        return;
      }

      await UpdateOemAsync({
        ...selectedOem,
        settings: {
          ...selectedOem.settings,
          allowSetPresetFromControlPanel: nextAllowSettingPresetFromCp,
        },
      });

      if (isHumphreeUser) {
        const updatedOems = await GetOems();
        dispatch({
          type: ActionType.ADD_OEMS,
          payload: updatedOems,
        });
      } else {
        const res = await GetOem(currentOemTenantId);

        if (res.parentOEMTenantId === null) {
          const indirectOems = await GetOemsIndirect(currentOemTenantId);
          dispatch({
            type: ActionType.ADD_OEMS,
            payload: indirectOems as any,
          });
        }

        setCurrentOem(res);
      }

      dispatch({
        type: ActionType.SET_SNACKBAR,
        payload: { heading: 'Successfully updated customer settings!', status: 'success' },
      });
    },
  });

  if (!selectedOem) {
    return <LoadingSpinner />;
  }

  return (
    <div className='flex flex-col pt-8'>
      <div className='flex flex-col border-b border-gray-10 pb-5'>
        <span className='prose-heading4 pb-2'>Customer settings</span>
        <span className='prose-paragraphSmall text-gray-60'>Edit customer-specific defaults.</span>

        <div className='flex flex-row justify-between w-full mt-6'>
          <div className='flex flex-row gap-2 items-center justify-start'>
            <span className='prose-paragraphBase text-gray-100'>
              Allow assigning boat model and preset from control panel
            </span>
            <Tooltip description='Allow customers to assign preset and boat model directly from control panel. The default is disabled.' />
          </div>

          <ToggleButton
            onClick={toggleAllowSettingPresetFromCp}
            toggled={allowSettingPresetFromCp}
            buttonClassName={isUpdating ? 'pointer-events-none opacity-30' : ''}
          />
        </div>
      </div>
    </div>
  );
};
